import React, { useReducer } from 'react';
import bluebookReducer, { initialState } from './reducer';

export const BluebookContext = React.createContext();

export const BluebookProvider = ({ initState, children }) => {
  const [state, dispatch] = useReducer(bluebookReducer, {
    ...initialState,
    // we want to preload state with data paassed directly to component
    ...initState,
  });
  const store = React.useMemo(() => ({ state, dispatch }), [state]);

  return (
    <BluebookContext.Provider value={store}>
      {children}
    </BluebookContext.Provider>
  );
};

export const withBluebookContext = (WrappedComponent) => (props) => (
  <BluebookProvider>
    <WrappedComponent {...props} />
  </BluebookProvider>
);
